import analytics from './analytics';

// init reassurance content and create slider
function initReassuranceContent() {
    const $slideLength = $(".reassurance-content-wrapper .reassurance-item").length;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const $slider = $('.reassurance-content-wrapper');
    const $windowWidth = $(window).width();
    let resumeTimer = null;
    let isInteracting = false;
    if($slideLength > 1 && !$slider.hasClass('slick-initialized')) {
        $slider.on('init', function(event, slick) {
            if (!slick || !slick.$slides) return; // check if slick exists
            $(this).addClass('is-ready-reassurance');
            $('.reassurance-item.slick-active').attr('tabindex', '0');
        });
        $slider.slick({
            dots: true,
            accessibility: false,
            initialSlide: 0,
            autoplay: !prefersReducedMotion,
            autoplaySpeed: 2000,
            arrows: true,
            infinite: true,
            speed: 200,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            pauseOnFocus: true,
            pauseOnHover: false,
            pauseOnDotsHover: true,
            focusOnChange: false,
            nextArrow: '<div class="slick-btn-wrapper"><button class="slick-next" aria-label="Next slide" tabindex="0"><span class="next"></span></button></div>',
            prevArrow: '<div class="slick-btn-wrapper"><button class="slick-prev" aria-label="Previous slide" tabindex="0"><span class="prev"></span></button></div>'
        }).on('afterChange', function() {
            updateAriaCurrent();
            addAccessibilityToDots();
            $('.reassurance-item.slick-slide').attr('tabindex', '-1'); // remove all
            $('.reassurance-item.slick-active').attr('tabindex', '0'); // only active slides
        });
    } else {
        $('.reassurance-content-wrapper .reassurance-item').attr('tabindex', '0');
    }

    // execute only for desktop
    if($windowWidth > 768) {
        //  Interaction start
        $slider.on('mouseenter focusin', function () {
            isInteracting = true;
            clearTimeout(resumeTimer);
            pauseSlickAutoPlay();
        });

        //  Interaction end 
        $slider.on('mouseleave focusout', function () {
            isInteracting = false;
            resumeWithDelay();
        });
        
    }
}

//  Helpers for accessibility 
function pauseSlickAutoPlay() {
    const $slider = $('.reassurance-content-wrapper');
    $slider.slick('slickPause');
}

// Helper to resume delay on mouse out
function resumeWithDelay() {
    let resumeTimer = null;
    let isInteracting = false;
    const $slider = $('.reassurance-content-wrapper');
    clearTimeout(resumeTimer);
    resumeTimer = setTimeout(() => {
        if (!isInteracting) {
            $slider.slick('slickPlay');
        }
    }, 200); // resume after 200ms
}

// add accessibility to dots with given aria-label
function addAccessibilityToDots() {
    $('.reassurance-content-wrapper .slick-dots li').each(function (index) {
        $(this).find('button').attr('aria-label', `Go to slide ${index + 1}`);
    });
}

// update aria current on active slide dots
function updateAriaCurrent() {
  $('.reassurance-content-wrapper .slick-dots li').each(function () {
    const $btn = $(this).find('button');
    if ($(this).hasClass('slick-active')) {
        $btn.attr('aria-current', 'true');
    } else {
        $btn.removeAttr('aria-current');
    }
  });
}

// click on reassurance item handler
function reassuranceItemHandler() {
    $('.reassurance-content-wrapper').on('click keydown', '.reassurance-item', function (e) {
        if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
            return;
        }

        if (e.type === 'keydown') {
            e.preventDefault(); // prevent scroll on Space
        }
        
        e.stopImmediatePropagation();
        if($(this).hasClass('open-reinsurance-panel')) {
            const $this = $(this);
            const clickedIndex = $(".reassurance-item").index(this);
            $(this).prop('disabled', false);
            const contentAssetId = $(this).attr('data-content-id');
            openReassurancePanel(contentAssetId);
            analytics.reassuranceCheckoutDatalayer($this, clickedIndex);
        }
    });
}

//open slide panel on click ajax call - this is existing function
function openReassurancePanel(contentAssetId) {
    const $reassurancePanel = $('.reinsurance-panel');
    const $panelBodyElelement = $reassurancePanel.find('.panel-body');
    const $panelBodyContent = $panelBodyElelement.find('.panel-body-content');
    const isTablet = window.matchMedia("(max-width: 768px)").matches;
    let panelBodyHeight;
    $.ajax({
        url: Urls.displayReinsuranceOverlay + '?cid=' + contentAssetId,
        type: 'GET'
    }).done(function (response) {
        $reassurancePanel.removeAttr('style').addClass('opened');
        $('html').addClass('filter-open');
        $reassurancePanel.find('.panel-header h3').html(response.name);
        $panelBodyContent.html(response.content);
        $('.panel-content-buttons .panel-bottom-yes, .panel-content-buttons .panel-bottom-no')
            .removeClass("activeReinsuranceRatingButton")
            .css("pointer-events", "auto");
        const panelHeight = $(".reinsurance-panel .panel-wrapper").height();
        if (isTablet) {
            panelBodyHeight = $panelBodyContent.height() + 240;
        } else {
            panelBodyHeight = $panelBodyContent.height() + 220;
        }

        if (panelBodyHeight > panelHeight) {
            $panelBodyElelement.find('.panel-bottom-content').css({
                'position': 'static',
                'margin-bottom': '0'
            });
        } else {
            $panelBodyElelement.find('.panel-bottom-content').css({
                'position': 'absolute',
                'margin-bottom': '40px'
            });
        }
    });
}

$(window).on('load', function() {
    // hide if slot is not configured
    if($(".reassurance-content-wrapper .reassurance-item").length) {
        initReassuranceContent();
    } else {
        $(".reassurance-content-wrapper").hide();
    }
    addAccessibilityToDots();
    updateAriaCurrent();
});

// export initializer
export default {
    init: function() {
        reassuranceItemHandler();
        initReassuranceContent();
    }
};